<template>
  <div
    class="
      cover-test
      d-flex
      align-items-center
      justify-content-center
      mt-3 mt-md-0
    "
  >
    <div class="bg-white shadow-sm p-4 p-md-5">
      <LoaderContent
        v-if="isLoading"
        :welcomeMessage="false"
        :alignSpinnerTop="true"
      />

      <div class="col-12 d-flex align-items-center">
        <img class="icon-file" src="@/assets/images/test.svg" alt="icon-file" />
        <div>
          <h5 class="text-secondary">{{ cover.name }}</h5>
          <em class="title-opportunity">{{ opportunity() }}</em>
        </div>
      </div>

      <hr class="mb-4" />

      <div class="cover-description" v-html="this.cover.description"></div>

      <div class="box-test">
        <p class="total">
          Você responderá a
          <span>{{ this.cover.qtd_of_questions }} questões</span>
        </p>
      </div>

      <router-link
        :to="`/vagas/${this.$route.params.id}/inscricao/${this.header_test.id}/teste/${this.first_question}`"
        class="
          btn btn-blue-ml btn-lg
          d-flex
          align-items-center
          justify-content-between
          btn-start
          mt-4
        "
      >
        Começar
        <chevron-right-icon class="h3 ml-5 mb-0" />
      </router-link>
    </div>
  </div>
</template>

<script>
import ChevronRightIcon from "vue-material-design-icons/ChevronRight.vue";
import LoaderContent from "../Loader/LoaderContent.vue";

export default {
  name: "ComponentCoverTest",

  props: {
    image: String,
  },

  data() {
    return {
      cover: [],
      header_test: [],
      first_question: "",
      isLoading: false,
    };
  },

  mounted() {
    this.isLoading = true;
    this.$store
      .dispatch("tests/testCover", {
        opportunityId: this.opportunityId,
        testId: this.$route.params.testId,
      })
      .then((cover) => {
        const { first_question } = cover.testCover.json.header_test.links;

        this.cover = cover.testCover.json.header_test.test;
        this.header_test = cover.testCover.json.header_test;
        this.first_question = first_question.match(/\d+/g, " ")[3];
        this.$store.commit("tests/SET_TEST_NAVIGATION_CONTROL", {
          can_edit: this.cover.can_edit,
          test_id: this.cover.id,
          cover_url: this.$route.path,
        });
        this.isLoading = false;
      })
      .catch((error) => {
        this.$swal(
          "Uoops",
          "Ocorreu um erro ao carregar o teste da oportunidade. Tente novamente...",
          "error"
        ).then(() => {
          this.isLoading = false;
          this.$router.push(`/vagas/${this.$route.params.id}/inscricao/testes`);
        });
      });
  },

  components: {
    LoaderContent,
    ChevronRightIcon,
  },

  computed: {
    opportunityId() {
      const id = this.$route.params.id.match(/\d+/)[0];
      return id;
    },
  },

  methods: {
    opportunity() {
      const title = this.$route.params.id.replace(/\d+/, "");
      return title.replace(/-(?!>)/g, " ");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
